import * as betprofessor from './Filters.styles.betprofessor';
import * as betroyale from './Filters.styles.betroyale';
import * as fiestabet from './Filters.styles.fiestabet';
import * as goldenrush from './Filters.styles.goldenrush';
import * as juicybet from './Filters.styles.juicybet';
import * as puntcity from './Filters.styles.puntcity';
import * as puntgenie from './Filters.styles.puntgenie';
import * as questbet from './Filters.styles.questbet';
import * as sterlingparker from './Filters.styles.sterlingparker';
import * as vikingbet from './Filters.styles.vikingbet';
import * as volcanobet from './Filters.styles.volcanobet';
import * as junglebet from './Filters.styles.junglebet';
import * as betstride from './Filters.styles.betstride';
import * as forsport from './Filters.styles.forsport';
import * as oldgill from './Filters.styles.oldgill';
import * as sugarcastle from './Filters.styles.sugarcastle';
import * as buffalobet from './Filters.styles.buffalobet';
import * as titanbet from './Filters.styles.titanbet';
import * as bet777 from './Filters.styles.bet777';
import * as templebet from './Filters.styles.templebet';
import * as goldenbet888 from './Filters.styles.goldenbet888';
import * as slambet from './Filters.styles.slambet';
import * as gigabet from './Filters.styles.gigabet';
import * as hyperbet from './Filters.styles.hyperbet';
import * as chromabet from './Filters.styles.chromabet';
import * as bet575 from './Filters.styles.bet575';
import * as betblast from './Filters.styles.betblast';
import * as magnumbet from './Filters.styles.magnumbet';
import * as pyramidbet from './Filters.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  betstride,
  forsport,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  templebet,
  goldenbet888,
  slambet,
  gigabet,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  magnumbet,
  pyramidbet,
};
